import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models/user';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-user]',
  template: `
    <td>{{user?.name}} {{user?.last_name}}</td>
    <td>{{user?.email}}</td>
    <td>
      <button type="button" routerLink="profile/{{user?.id}}" *ngIf="authService.hasPermission('can_edit_users')" class="btn btn-link pt-0 pe-0">
        <fa-icon [icon]="icons.faEdit" size="1x"></fa-icon>
      </button>
      <button type="button" class="btn btn-link text-danger ms-1 pt-0 pe-0" *ngIf="authService.hasPermission('can_delete_users')" (click)="removeUser(user!)">
        <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrUserComponent {
  @Input() user: User | null = null;
  @Output() updateData = new EventEmitter<any>();

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {}

  removeUser(user: User) {
    this.store.destroyUser(user.id).subscribe({
      next: (data: any) => {
        this.toastr.success('Usuario eliminado correctamente.', 'Éxito');
        this.updateData.emit();
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al eliminar el usuario.', 'Error');        
      },
    });
  }
}
